export interface Locale {
  language: string;
  country: string;
  [extra: string]: unknown;
}

export const FALLBACK_LOCALE = 'pt_BR';

/** `${language}_${country}` — o identificador ativo do idioma, espelhando `translate.use` do Angular. */
export function buildLocaleId(locale: Locale): string {
  return `${locale.language}_${locale.country}`;
}

/** Valor persistido em `localStorage['locale']` quando presente e não vazio; senão o fallback pt_BR. */
export function resolveActiveLocale(stored: string | null): string {
  return stored && stored.length > 0 ? stored : FALLBACK_LOCALE;
}
